module.exports = __webpack_public_path__ + "img/s1.197c0c48.svg";